import { render } from "./Disabled.vue?vue&type=template&id=81a32130"
import script from "./Disabled.vue?vue&type=script&lang=js"
export * from "./Disabled.vue?vue&type=script&lang=js"
script.render = render

export default script